/**
 * Phone validation function
 */

module.exports = function Phone(phone) {
  this.phone = String(phone);

  /**
   * Remove non-digital letters from phone
   */
  this.clean = function clean() {
    return this.phone.split('').filter(v => '0123456789'.indexOf(v) >= 0).join('');
  };

  /**
   * Normalize cleaned phone
   */
  this.normalize = function normalize() {
    const p = this.clean();
    switch (p.length) {
      case 10:
        return `7${p}`;
      case 11:
        if (p[0] === '8') {
          return `7${p.slice(1)}`;
        }
        return p;
      default:
        return p;
    }
  };

  /**
   * Validate phone
   */
  this.valid = function valid() {
    return this.normalize().length === 11;
  };

  /**
   * Format classic '+7 (000) 123-45-67'
   */
  this.format = function format() {
    if (this.valid()) {
      const p = this.normalize();
      return `+7 (${p.slice(1, 4)}) ${p.slice(4, 7)}-${p.slice(7, 9)}-${p.slice(9, 11)}`;
    }
    return this.phone;
  };

  /**
   * Format spaces '+7 000 123 45 67'
   */
  this.formatSpaces = function formatSpaces() {
    if (this.valid()) {
      const p = this.normalize();
      return `+7 ${p.slice(1, 4)} ${p.slice(4, 7)} ${p.slice(7, 9)} ${p.slice(9, 11)}`;
    }
    return this.phone;
  };
};
